import React from "react"
import {Table} from "antd";
import {useParams} from "react-router";
import {useGetOnceHttp} from "../hooks/inithttp.hook";


const NsiPage = ({}) => {
    const {nsi} = useParams()
    const [data] = useGetOnceHttp({url: `/api/nsi/oid/${nsi}`, def: []})
    const columns = data[0] ? Object.keys(data[0]).map(key => ({
       title: key,
       dataIndex: key
    })) : []
    return <Table
        dataSource={data}
        columns={columns}
    />
}

export default  NsiPage